import fetch from '@/plugin/axios'

export function oilProtocolList (query) {
    return fetch({
        url: '/api/admin/common/oilProtocolList',
        method: 'get',
        params: query
    })
}

export function liveInfo (query) {
    return fetch({
        url: '/api/admin/common/liveInfo',
        method: 'get',
        params: query
    })
}

export function liveList(query) {
    return fetch({
        url: '/api/admin/common/liveList',
        method: 'get',
        params: query
    })
}